import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { RootState } from './reducers/store';
import { AccountLogin, AccountRegister, EditAdmin, Home, PageNotFound, ViewAdmins, Messages } from './pages';
 
import { Loader, Navbar, SideNavigation } from './components';
import './components/table/tableFields.css'

const App = () => {
  const navigate                          = useNavigate();
  const [authData, setAuthData]           = useState<{ token?: string; result?: any } | null>(null);
  const [user, setUser]                   = useState<any>(null);
  const [isLoadingPage, setIsLoadingPage] = useState<boolean>(true);
  const { modeValue }                     = useSelector((state: RootState) => state?.modeList);
  const [sideNavToggle, setSideNavToggle] = useState(false)
  const [theme, setTheme]                 = useState(modeValue);

  //police
  useEffect(() => {
    const storedAuthData = localStorage.getItem("authData");
    const parsedData = storedAuthData ? JSON.parse(storedAuthData) : null;

    setAuthData(parsedData);
    setUser(parsedData?.result || null);
    setIsLoadingPage(false);
  }, [navigate]); 

  useEffect(() => {
    setTheme(modeValue);
  }, [modeValue]);

  const toggleTheme = () => {
    setTheme(modeValue === "light" ? "dark" : "light");
  };

  const handleClickSideNav = () => {
    setSideNavToggle((prev) => !prev)
  }

  if (isLoadingPage){
    return (
      <div>
        <Loader />
      </div>
    )
  }
  
  return (
    <div id={theme} className='cover-container'>
      <Toaster position='top-center' reverseOrder={false} gutter={8} toastOptions={{ className: 'toast-option' }} containerStyle={{top: '15%', }}></Toaster>
      <SideNavigation sideNavToggle={sideNavToggle} handleClickSideNav={handleClickSideNav} user={user} setUser={setUser} authData={authData} toggleTheme={toggleTheme} />
       
      <div className={sideNavToggle ? "main-container" : "main-container active"} id={theme}>
        <Navbar theme={theme} user={user} />
        <Routes>
          <Route path="/" element={authData ? (<Home />) : (<Navigate to='/login' replace />)} />
          <Route path="/login" element={!authData ? (<AccountLogin />) : (<Navigate to="/" replace />) } />

          <Route path="/register" element={!authData ? (<AccountRegister />) : (<Navigate to="/" replace />) } />
          <Route path='/admins/view-admins' element={authData ? (<ViewAdmins user={user} />) : (<Navigate to='/login' replace />)} />
          <Route path='/admins/edit-admin/:id' element={authData ? (<EditAdmin />) : (<Navigate to='/login' replace />)} />

          <Route path='/messages' element={authData ? (<Messages />) : (<Navigate to='/login' replace />)} />

          <Route path='/page-not-found' element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/page-not-found" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default App